// extracted by mini-css-extract-plugin
module.exports = {"container":"container_3J-pl","heading":"heading_241C2","infoItem":"infoItem_1kvVD"};